import {type EmptyObject} from '~/utils/types'
import {SimpleAPI, Method} from '~/mercuryWebBackend/SimpleAPI'

export type NumberOfClients =
  | 'oneToTen'
  | 'tenToFifty'
  | 'fiftyToOneHundred'
  | 'oneHundredToOneThousand'
  | 'oneThousandPlus'

export type FoundersStage =
  | 'ideaOrPreProduct'
  | 'preSeed'
  | 'seed'
  | 'seriesA'
  | 'seriesB'
  | 'seriesCPlus'
  | 'lessThan100KAnnualRevenueCompanies'
  | 'oneMillionToTenMillionAnnualRevenueCompanies'
  | 'tenMillionPlusAnnualRevenueCompanies'
  | 'notApplicable'

export type ContactPartnershipsParams = {
  firstName: string
  lastName?: string
  email: string
  companyName: string
  companyWebsite: string
  organizationType: string[]
  foundersStage: FoundersStage[]
  numberOfClients: NumberOfClients
  howWouldYouLikeToPartner: string
}

export class ContactPartnerships extends SimpleAPI<
  EmptyObject,
  ContactPartnershipsParams
> {
  revalidate = 'client-only' as const
  method = Method.POST

  getPath() {
    return '/contact/partnerships'
  }

  protected async getMockResponse() {
    return {}
  }
}
